<template>
  <div class="public-footer">
    <div class="public-container public-container-mobile">
      <div class="public-footer-top flex flex-space-between flex-align-items-center">
        <public-header-region />
        <div class="public-footer-top-description">
          Автомобильные грузоперевозки с компанией Возовоз - одной из ведущих транспортных компаний в России
        </div>
      </div>
      <div class="public-footer-main flex flex-space-between">
        <div class="public-footer-info">
          <vz-logo variant="white"/>
          <public-footer-apps/>
        </div>
        <public-footer-menu/>
        <public-footer-contacts/>
      </div>

      <public-footer-apps class="public-footer-apps-mobile"/>

      <div class="public-footer-additional flex">
        <div>
          <span itemprop="name">OOO "Возовоз"</span> © 2014 - {{ year }}
          <span class="display-none" itemprop="address">
            {{ address }}
          </span>
        </div>
        <a :href="linkCountryCookie" download target="_blank" class="public-footer-additional-link">
          Политика обработки cookie-файлов
        </a>
        <a  v-if="!isBYKZ" :href="personalDataPolicy" target="_blank" class="public-footer-additional-link personal-data-link">
          Обработка персональных данных
        </a>
      </div>
    </div>

    <client-only>
      <public-cookies />
    </client-only>
  </div>
</template>

<script setup lang="ts">
import VzLogo from '~/components/ui-kit/vz-logo.vue'
import PublicFooterApps from '~/components/public/footer/public-footer-apps.vue'
import PublicFooterMenu from '~/components/public/footer/public-footer-menu.vue'
import PublicHeaderRegion from '~/components/public/header/public-header-region.vue'
import PublicFooterContacts from '~/components/public/footer/public-footer-contacts.vue'
import {cookiePolicy, personalDataPolicy} from '@/api/constant-urls'
import {until} from '@vueuse/core';
import PublicCookies from "~/components/public/footer/public-cookies.vue";

const { terminalList } = storeToRefs(useTerminalStore())
const { terminalSelectByLocation } = useTerminalStore()
const { from, to, rclCityList } = storeToRefs(useCityStore())

const route = useRoute()

const address = terminalSelectByLocation(from.value.rcl_guid || from.value?.guid)?.[0]?.address || 'Санкт-Петербург, 6-й Верхний переулок дом 12 литер А, кабинет №210'

const isBYKZ = computed(() => {
  return ['BY', 'KZ'].includes(useDomainCountry().value)
})

const linkCountryCookie = computed(() => {
  const country = useDomainCountry().value.toLowerCase() === 'kg'? 'ru' : useDomainCountry().value.toLowerCase()
  return `https://vozovoz.${country}${cookiePolicy}`
})

const year = computed(() => {
  return new Date().getFullYear()
})
</script>
